import React, { useState, useMemo } from 'react';
import NavigationBar from '../navbar/NavigationBar';
import Footer from '../navbar/Footer';
import SideMenu from '../navbar/SideMenu';
import SideMenuBuhumuza from '../navbar/SideMenuButanyerera'; 
import {
  Box,
  Typography,
  Container,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Grid,
  TextField,
  List, 
  ListItem, 
  ListItemText,
  CssBaseline,
  Drawer,
  InputAdornment,
  Button,
  useTheme,
  styled,
  useMediaQuery,
  Collapse,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Card,
  CardContent,
  Chip,
  LinearProgress,
  Stack
} from '@mui/material';

import {
  ExpandLess,
  Search,
  Menu as MenuIcon,
  ExpandMore,
  LocationOn,
  TrendingUp,
  TrendingDown,
  Group
} from '@mui/icons-material';


const drawerWidth = 240;
const rightDrawerWidth = 280; 
const primaryColor = '#E30613';
const secondaryColor = '#008D36';
const backgroundColor = '#f5f5f5';


const MainContainer = styled('div')({
  display: 'flex',
  backgroundColor: backgroundColor,
  minHeight: '100vh',
  flexDirection: 'column'
});

const MainContentWithDrawer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexGrow: 1,
  marginTop: '64px',
  overflow: 'hidden',
  [theme.breakpoints.down('sm')]: {
    marginTop: '56px'
  }
}));

const ContentWrapper = styled('main')(({ theme }) => ({
  flexGrow: 1,
  overflow: 'auto',
  padding: theme.spacing(2),
  backgroundColor: backgroundColor,
  height: 'calc(100vh - 64px)',
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(1),
    height: 'calc(100vh - 56px)'
  }
}));

const DrawerWrapper = styled('div')(({ theme }) => ({
  width: drawerWidth,
  flexShrink: 0,
  overflow: 'auto',
  height: 'calc(100vh - 64px)',
  borderRight: '1px solid rgba(0, 0, 0, 0.12)',
  backgroundColor: '#fff',
  [theme.breakpoints.down('md')]: {
    position: 'fixed',
    zIndex: 1300,
    transition: theme.transitions.create('transform', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    '&.drawerOpen': {
      transform: 'translateX(0)',
    },
    '&.drawerClose': {
      transform: 'translateX(-100%)',
    },
  }
}));

const RightDrawerWrapper = styled('div')(({ theme }) => ({
  width: rightDrawerWidth,
  flexShrink: 0,
  overflow: 'auto',
  height: 'calc(100vh - 64px)',
  borderLeft: '1px solid rgba(0, 0, 0, 0.12)',
  backgroundColor: '#fff',
  [theme.breakpoints.down('md')]: {
    position: 'fixed',
    right: 0,
    zIndex: 1300,
    transition: theme.transitions.create('transform', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    '&.drawerOpen': {
      transform: 'translateX(0)',
    },
    '&.drawerClose': {
      transform: 'translateX(100%)',
    },
  }
}));

const StyledTableHead = styled(TableHead)({
  backgroundColor: primaryColor,
  '& th': {
    color: 'white',
    fontWeight: 'bold'
  }
});


const ZoneRow = styled(TableRow)({
  backgroundColor: '#f8f8f8',
  fontWeight: 'bold',
  '&:hover': {
    backgroundColor: '#e8e8e8 !important'
  }
});

const kayanzaData = {
  title: "RÉPARTITION DE LA POPULATION DE LA COMMUNE DE KAYANZA PAR ZONE ET COLLINE",
  province: {
    id: "1",
    name: "BUHUMUZA",
    commune: {
      id: "101",
      name: "KAYANZA",
      total: 330304,
      zones: [
        {
          id: "10101",
          name: "PARC DE LA KIBI",
          total: 0,
          collines: [
            { id: "10101101", name: "PARC DE LA KIBIRA", population: 0 }
          ]
        },
        {
          id: "10102",
          name: "JENE",
          total: 27070,
          collines: [
            { id: "10102101", name: "NGOMA", population: 3585 },
            { id: "10102102", name: "JENE", population: 3625 },
            { id: "10102103", name: "SONGORE", population: 1339 },
            { id: "10102104", name: "MUGOYI", population: 3849 },
            { id: "10102105", name: "RYAMUKONA", population: 3403 },
            { id: "10102106", name: "KIGERI", population: 1759 },
            { id: "10102107", name: "YANDARO", population: 2839 },
            { id: "10102108", name: "MUTANA", population: 1951 },
            { id: "10102109", name: "RUHINGA", population: 1772 },
            { id: "10102110", name: "RUSAMBI", population: 1570 },
            { id: "10102111", name: "KIBUBA", population: 1378 }
          ]
        },
        {
          id: "10103",
          name: "KABARORE",
          total: 23672,
          collines: [
            { id: "10103101", name: "KIVUVU", population: 3592 },
            { id: "10103102", name: "KIREHE", population: 3523 },
            { id: "10103103", name: "CAGUKA", population: 2991 },
            { id: "10103104", name: "MUGONGO", population: 2905 },
            { id: "10103105", name: "MUGERA", population: 3185 },
            { id: "10103106", name: "MUNEGE", population: 2557 },
            { id: "10103107", name: "NYAMISAGARA", population: 2436 },
            { id: "10103108", name: "GIKINGO", population: 1141 },
            { id: "10103109", name: "KIDUNDURI", population: 1342 }
          ]
        },
        {
          id: "10104",
          name: "KABUYE",
          total: 27033,
          collines: [
            { id: "10104101", name: "RYIRENGEYE", population: 3510 },
            { id: "10104102", name: "KINZOBE", population: 3604 },
            { id: "10104103", name: "SHIKANKONI", population: 1968 },
            { id: "10104104", name: "NYANGWE", population: 3084 },
            { id: "10104105", name: "BENGA", population: 2646 },
            { id: "10104106", name: "NTARAMBO", population: 2911 },
            { id: "10104107", name: "MARURI", population: 1820 },
            { id: "10104108", name: "MIGEGE", population: 1989 },
            { id: "10104109", name: "NYABIKARANKA", population: 2510 },
            { id: "10104110", name: "KINYAMUKIZI", population: 1552 },
            { id: "10104111", name: "MPANGA", population: 1439 }
          ]
        },
        {
          id: "10105",
          name: "KAYANZA",
          total: 75925,
          collines: [
            { id: "10105101", name: "QUARTIER MUSAVE", population: 36327 },
            { id: "10105102", name: "QUARTIER KIREMA", population: 10443 },
            { id: "10105103", name: "MIHIGO", population: 3725 },
            { id: "10105104", name: "BUBEZI", population: 3705 },
            { id: "10105105", name: "NYABIHANGA", population: 3134 },
            { id: "10105106", name: "KINGA", population: 4152 },
            { id: "10105107", name: "MWENDO", population: 3251 },
            { id: "10105108", name: "GAHAHE", population: 3216 },
            { id: "10105109", name: "KARINZI", population: 3229 },
            { id: "10105110", name: "MURAGO", population: 2224 },
            { id: "10105111", name: "CUKIRO", population: 2519 }
          ]
        },
        {
          id: "10106",
          name: "MPARAMIRUNDI",
          total: 27831,
          collines: [
            { id: "10106101", name: "MPARAMIRUNDI", population: 4683 },
            { id: "10106102", name: "TUBIRI", population: 2760 },
            { id: "10106103", name: "KINYAMI", population: 2481 },
            { id: "10106104", name: "MIHAMA", population: 2647 },
            { id: "10106105", name: "GITEMEZI", population: 1939 },
            { id: "10106106", name: "MUNYANGE", population: 1765 },
            { id: "10106107", name: "CENDAJURU", population: 2757 },
            { id: "10106108", name: "MUTSINDA", population: 2151 },
            { id: "10106109", name: "MAGANA", population: 1459 },
            { id: "10106110", name: "GAHINI", population: 1376 },
            { id: "10106111", name: "BIGERA", population: 1355 },
            { id: "10106112", name: "NYAMISEBO", population: 1077 },
            { id: "10106113", name: "MAKOMBE", population: 1381 }
          ]
        },
        {
          id: "10107",
          name: "MURIMA",
          total: 18851,
          collines: [
            { id: "10107101", name: "MAGAMBA", population: 1965 },
            { id: "10107102", name: "KAVUMU", population: 2611 },
            { id: "10107103", name: "KIBINGO", population: 2854 },
            { id: "10107104", name: "GIHORORO", population: 1956 },
            { id: "10107105", name: "MURIMA", population: 2118 },
            { id: "10107106", name: "NKUBA", population: 1651 },
            { id: "10107107", name: "GACU", population: 1608 },
            { id: "10107108", name: "RWINTARE", population: 1539 },
            { id: "10107109", name: "CANZARA", population: 1513 },
            { id: "10107110", name: "RUVOMO", population: 1036 }
          ]
        },
        {
          id: "10108",
          name: "MURUTA",
          total: 32489,
          collines: [
            { id: "10108101", name: "REMERA", population: 4793 },
            { id: "10108102", name: "BUZIRAGUHINDWA", population: 3332 },
            { id: "10108103", name: "KARUNYINYA", population: 3314 },
            { id: "10108104", name: "YANZA", population: 3894 },
            { id: "10108105", name: "KAVOGA", population: 3878 },
            { id: "10108106", name: "MURUTA", population: 3363 },
            { id: "10108107", name: "NYAMIYOGORO", population: 3295 },
            { id: "10108108", name: "BUSAMBO", population: 2319 },
            { id: "10108109", name: "MANINI", population: 1956 },
            { id: "10108110", name: "MYUGARIRO", population: 2345 }
          ]
        },
        {
          id: "10109",
          name: "NKONGE",
          total: 19473,
          collines: [
            { id: "10109101", name: "MIKUBA", population: 4592 },
            { id: "10109102", name: "MUTANA", population: 3011 },
            { id: "10109103", name: "NKONGE", population: 3089 },
            { id: "10109104", name: "GISHUBI", population: 2359 },
            { id: "10109105", name: "CAMPAZI", population: 3018 },
            { id: "10109106", name: "RUVUMU", population: 2267 },
            { id: "10109107", name: "NYAKIBARI", population: 1137 }
          ]
        },
        {
          id: "10110",
          name: "NYABIHOGO",
          total: 14739,
          collines: [
            { id: "10110101", name: "GITWA", population: 3875 },
            { id: "10110102", name: "MUHWEZA", population: 2753 },
            { id: "10110103", name: "RUHANDE", population: 2407 },
            { id: "10110104", name: "NYABIHOGO", population: 2605 },
            { id: "10110105", name: "NEMBA", population: 3099 }
          ]
        },
        {
          id: "10111",
          name: "RUGAZI",
          total: 23560,
          collines: [
            { id: "10111101", name: "BUYUMPU", population: 4416 },
            { id: "10111102", name: "TONDERO", population: 4234 },
            { id: "10111103", name: "GASHIRU", population: 1606 },
            { id: "10111104", name: "GISAGARA", population: 2518 },
            { id: "10111105", name: "YANZA", population: 2404 },
            { id: "10111106", name: "BUVUMO", population: 2386 },
            { id: "10111107", name: "KIBATI", population: 2918 },
            { id: "10111108", name: "DUSASA", population: 3072 },
            { id: "10111109", name: "PARC DE LA KIBIRA", population: 6 }
          ]
        },
        {
          id: "10112",
          name: "RUKERE",
          total: 14401,
          collines: [
            { id: "10112101", name: "MANGA", population: 2762 },
            { id: "10112102", name: "RUKERE", population: 2624 },
            { id: "10112103", name: "RORERO", population: 1625 },
            { id: "10112104", name: "RUHORORO", population: 1268 },
            { id: "10112105", name: "RANDA", population: 1577 },
            { id: "10112106", name: "RUNYINYA", population: 1177 },
            { id: "10112107", name: "KARAMA", population: 1160 },
            { id: "10112108", name: "RUTEGA", population: 1142 },
            { id: "10112109", name: "CARATSI", population: 1066 }
          ]
        },
        {
          id: "10113",
          name: "RWEGURA",
          total: 25260,
          collines: [
            { id: "10113101", name: "MUGANZA", population: 4112 },
            { id: "10113102", name: "KASEREGE", population: 4311 },
            { id: "10113103", name: "MPFUNDA", population: 4498 },
            { id: "10113104", name: "KIBAYA", population: 4439 },
            { id: "10113105", name: "RWAGONGWE", population: 3085 },
            { id: "10113106", name: "RWEGURA", population: 2872 },
            { id: "10113107", name: "KIBAKWE", population: 1943 }
          ]
        }
      ]
    }
  }
};

const PopulationDataPageButanyereraKayanza = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [searchTerm, setSearchTerm] = useState('');
  const [mobileOpen, setMobileOpen] = useState(false);
  const [mobileRightOpen, setMobileRightOpen] = useState(false);
  const [expandedZones, setExpandedZones] = useState({});
  const [openKeyStats, setOpenKeyStats] = useState(true);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleRightDrawerToggle = () => {
    setMobileRightOpen(!mobileRightOpen);
  };

  const toggleZone = (zoneId) => {
    setExpandedZones(prev => ({
      ...prev,
      [zoneId]: !prev[zoneId]
    }));
  };

  const filterData = (data, searchTerm) => {
    if (!searchTerm) return data;
    
    const filteredZones = data.province.commune.zones.map(zone => {
      const filteredCollines = zone.collines.filter(colline =>
        colline.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        zone.name.toLowerCase().includes(searchTerm.toLowerCase())
      );
      
      return {
        ...zone,
        collines: filteredCollines,
        show: filteredCollines.length > 0 || 
              zone.name.toLowerCase().includes(searchTerm.toLowerCase())
      };
    }).filter(zone => zone.show || !searchTerm);
    
    return {
      ...data,
      province: {
        ...data.province,
        commune: {
          ...data.province.commune,
          zones: filteredZones
        }
      }
    };
  };

  const filteredData = filterData(kayanzaData, searchTerm);

  const keyStats = useMemo(() => {
    const commune = kayanzaData.province.commune;
    
    const mostPopulatedZone = commune.zones.reduce((max, zone) => 
      zone.total > max.total ? zone : max, commune.zones[0]);
    
    const leastPopulatedZone = commune.zones.reduce((min, zone) => 
      zone.total < min.total ? zone : min, commune.zones[0]);
    
    const mostPopulatedColline = commune.zones.flatMap(zone => zone.collines)
      .reduce((max, colline) => colline.population > max.population ? colline : max, commune.zones[0].collines[0]);
    
    const leastPopulatedColline = commune.zones.flatMap(zone => zone.collines)
      .reduce((min, colline) => colline.population < min.population ? colline : min, commune.zones[0].collines[0]);

    const zonePercentages = commune.zones.map(zone => ({
      ...zone,
      percentage: ((zone.total / commune.total) * 100).toFixed(1)
    }));
    
    return {
      totalPopulation: commune.total.toLocaleString(),
      totalZones: commune.zones.length,
      totalCollines: commune.zones.reduce((sum, zone) => sum + zone.collines.length, 0),
      mostPopulatedZone,
      leastPopulatedZone,
      mostPopulatedColline,
      leastPopulatedColline,
      zonePercentages,
      communeTotal: commune.total
    };
  }, []);

  return (
    <MainContainer>
      <CssBaseline />
      <NavigationBar />
      <MainContentWithDrawer>
        {!isMobile ? (
          <DrawerWrapper>
            <SideMenu /> 
          </DrawerWrapper>
        ) : (
          <Drawer
            variant="temporary"
            open={mobileOpen}
            onClose={handleDrawerToggle}
            ModalProps={{
              keepMounted: true,
            }}
            sx={{
              '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
            }}
          >
            <SideMenu />
          </Drawer>
        )}

       
        <ContentWrapper>
          <Container maxWidth="lg">
            {isMobile && (
              <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
                <Button 
                  variant="outlined" 
                  startIcon={<MenuIcon />} 
                  onClick={handleDrawerToggle}
                  sx={{ color: primaryColor, borderColor: primaryColor }}
                >
                  Menu
                </Button>
                <Button 
                  variant="outlined" 
                  endIcon={<MenuIcon />} 
                  onClick={handleRightDrawerToggle}
                  sx={{ color: secondaryColor, borderColor: secondaryColor }}
                >
                  Info KAYANZA
                </Button>
              </Box>
            )}
            
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Paper sx={{ p: { xs: 1, sm: 3 }, mb: 3, borderLeft: `4px solid ${primaryColor}` }}>
                  <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, justifyContent: 'space-between', alignItems: { xs: 'flex-start', sm: 'center' }, mb: 2 }}>
                    <Typography variant="body1" component="h2" fontWeight="bold" color="primary" sx={{ mb: { xs: 1, sm: 0 } }}>
                      {kayanzaData.title}
                    </Typography>
                    <Chip 
                      icon={<Group />} 
                      label={`Commune de KAYANZA`} 
                      color="primary" 
                      variant="outlined" 
                    />
                  </Box>
                  
                  <Grid container spacing={1} style={{ marginTop: '5px', marginBottom: '5px' }}>
                    <Grid item xs={12} sm={6} md={6}></Grid>
                    <Grid item xs={12} sm={6} md={6}>
                      <TextField
                        size="small"
                        placeholder="Rechercher zone/colline..."
                        variant="outlined"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <Search />
                            </InputAdornment>
                          ),
                        }}
                        sx={{ width: { xs: '100%', sm: '400px' } }}
                      />
                    </Grid>
                  </Grid>
                
                  <Accordion expanded={openKeyStats} onChange={() => setOpenKeyStats(!openKeyStats)} sx={{ mb: 3 }}>
                    <AccordionSummary expandIcon={<ExpandMore />}>
                      <Typography variant="subtitle1" fontWeight="bold">
                         Commune de KAYANZA
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Grid container spacing={2}>
                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${primaryColor}` }}>
                            <CardContent>
                              <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                                Population Totale
                              </Typography>
                              <Typography variant="h4" fontWeight="bold" color="primary">
                                {keyStats.totalPopulation}
                              </Typography>
                              <Typography variant="caption">
                                Habitants
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                        
                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${secondaryColor}` }}>
                            <CardContent>
                              <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                                Nombre de Zones
                              </Typography>
                              <Typography variant="h4" fontWeight="bold" color="secondary">
                                {keyStats.totalZones}
                              </Typography>
                              <Typography variant="caption">
                                Zones répertoriées
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                        
                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${primaryColor}` }}>
                            <CardContent>
                              <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                                Nombre de Collines
                              </Typography>
                              <Typography variant="h4" fontWeight="bold">
                                {keyStats.totalCollines}
                              </Typography>
                              <Typography variant="caption">
                                Collines répertoriées
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                        
                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${secondaryColor}` }}>
                            <CardContent>
                              <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1 }}>
                                <TrendingUp fontSize="small" color="success" />
                                <Typography variant="subtitle2" color="text.secondary">
                                  Zone la plus peuplée
                                </Typography>
                              </Stack>
                              <Typography variant="h6" fontWeight="bold">
                                {keyStats.mostPopulatedZone.name}
                              </Typography>
                              <Stack direction="row" spacing={1} alignItems="baseline">
                                <Typography variant="body1">
                                  {keyStats.mostPopulatedZone.total.toLocaleString()}
                                </Typography>
                                <Typography variant="caption" color="text.secondary">
                                  ({((keyStats.mostPopulatedZone.total / keyStats.communeTotal) * 100).toFixed(1)}%)
                                </Typography>
                              </Stack>
                            </CardContent>
                          </Card>
                        </Grid>
                        
                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${primaryColor}` }}>
                            <CardContent>
                              <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1 }}>
                                <TrendingDown fontSize="small" color="error" />
                                <Typography variant="subtitle2" color="text.secondary">
                                  Zone la moins peuplée
                                </Typography>
                              </Stack>
                              <Typography variant="h6" fontWeight="bold">
                                {keyStats.leastPopulatedZone.name}
                              </Typography>
                              <Stack direction="row" spacing={1} alignItems="baseline">
                                <Typography variant="body1">
                                  {keyStats.leastPopulatedZone.total.toLocaleString()}
                                </Typography>
                                <Typography variant="caption" color="text.secondary">
                                  ({((keyStats.leastPopulatedZone.total / keyStats.communeTotal) * 100).toFixed(1)}%)
                                </Typography>
                              </Stack>
                            </CardContent>
                          </Card>
                        </Grid>

                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${secondaryColor}` }}>
                            <CardContent>
                              <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1 }}>
                                <TrendingUp fontSize="small" color="success" />
                                <Typography variant="subtitle2" color="text.secondary">
                                  Colline la plus peuplée
                                </Typography>
                              </Stack>
                              <Typography variant="h6" fontWeight="bold">
                                {keyStats.mostPopulatedColline.name}
                              </Typography>
                              <Typography variant="body1">
                                {keyStats.mostPopulatedColline.population.toLocaleString()}
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>

                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${primaryColor}` }}>
                            <CardContent>
                              <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1 }}>
                                <TrendingDown fontSize="small" color="error" />
                                <Typography variant="subtitle2" color="text.secondary">
                                  Colline la moins peuplée
                                </Typography>
                              </Stack>
                              <Typography variant="h6" fontWeight="bold">
                                {keyStats.leastPopulatedColline.name}
                              </Typography>
                              <Typography variant="body1">
                                {keyStats.leastPopulatedColline.population.toLocaleString()}
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                      </Grid>

                     
                      <Box sx={{ mt: 3 }}>
                        <Typography variant="subtitle1" gutterBottom fontWeight="bold">
                          Répartition de la population par zone
                        </Typography>
                        {keyStats.zonePercentages.map((zone) => (
                          <Box key={zone.id} sx={{ mb: 2 }}>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
                              <Typography variant="body2">
                                {zone.name}
                              </Typography>
                              <Typography variant="body2" fontWeight="bold">
                                {zone.percentage}% ({zone.total.toLocaleString()})
                              </Typography>
                            </Box>
                            <LinearProgress 
                              variant="determinate" 
                              value={zone.percentage} 
                              sx={{ 
                                height: 8, 
                                borderRadius: 4,
                                backgroundColor: '#e0e0e0',
                                '& .MuiLinearProgress-bar': {
                                  backgroundColor: zone.id === keyStats.mostPopulatedZone.id ? primaryColor : 
                                                zone.id === keyStats.leastPopulatedZone.id ? secondaryColor : '#888',
                                }
                              }} 
                            />
                          </Box>
                        ))}
                      </Box>
                    </AccordionDetails>
                  </Accordion>
                  
                  <TableContainer component={Paper} sx={{ mb: 2, overflowX: 'auto' }}>
                    <Table size="small" aria-label="Tableau des données démographiques">
                      <StyledTableHead>
                        <TableRow>
                          <TableCell>Zone/Colline</TableCell>
                          <TableCell align="right">Population</TableCell>
                        </TableRow>
                      </StyledTableHead>
                      <TableBody>
                        {filteredData.province.commune.zones.map((zone) => (
                          <React.Fragment key={zone.id}>
                            <ZoneRow 
                              hover 
                              onClick={() => toggleZone(zone.id)}
                              sx={{ cursor: 'pointer' }}
                            >
                              <TableCell component="th" scope="row" colSpan={2}>
                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                  {expandedZones[zone.id] ? <ExpandLess /> : <ExpandMore />}
                                  <LocationOn sx={{ mr: 1, color: primaryColor }} />
                                  {zone.name}
                                </Box>
                              </TableCell>
                            </ZoneRow>
                            
                            <TableRow>
                              <TableCell style={{ padding: 0 }} colSpan={2}>
                                <Collapse in={expandedZones[zone.id] || !!searchTerm} timeout="auto" unmountOnExit>
                                  <Table size="small" sx={{ backgroundColor: '#fafafa' }}>
                                    <TableBody>
                                      {zone.collines.map((colline) => (
                                        <TableRow key={colline.id} hover>
                                          <TableCell sx={{ pl: 4 }}>{colline.name}</TableCell>
                                          <TableCell align="right">{colline.population.toLocaleString()}</TableCell>
                                        </TableRow>
                                      ))}
                                      <TableRow>
                                        <TableCell sx={{ pl: 4, fontWeight: 'bold' }}>Total {zone.name}</TableCell>
                                        <TableCell align="right" sx={{ fontWeight: 'bold' }}>{zone.total.toLocaleString()}</TableCell>
                                      </TableRow>
                                    </TableBody>
                                  </Table>
                                </Collapse>
                              </TableCell>
                            </TableRow>
                          </React.Fragment>
                        ))}
                        <TableRow sx={{ backgroundColor: '#e0e0e0', fontWeight: 'bold' }}>
                          <TableCell>TOTAL COMMUNE DE KAYANZA</TableCell>
                          <TableCell align="right">{kayanzaData.province.commune.total.toLocaleString()}</TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>

                </Paper>
                
               
                <Accordion sx={{ mb: 2 }}>
                  <AccordionSummary expandIcon={<ExpandMore />}>
                    <Typography variant="subtitle2" color="primary">
                      Structure administrative - Commune de KAYANZA
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Typography variant="body2" paragraph>
                      La commune de KAYANZA est divisée en {keyStats.totalZones} zones administratives:
                    </Typography>
                    <List dense sx={{ py: 0 }}>
                      {keyStats.zonePercentages.map((zone, index) => (
                        <ListItem key={zone.id}>
                          <ListItemText 
                            primary={`${index + 1}. ${zone.name}`} 
                            secondary={`Population: ${zone.total.toLocaleString()} habitants (${zone.percentage}%) - ${zone.collines.length} collines`} 
                          />
                        </ListItem>
                      ))}
                    </List>
                  </AccordionDetails>
                </Accordion>
                
              
                <Paper sx={{ p: 2, backgroundColor: '#f0f0f0', borderLeft: `4px solid ${secondaryColor}` }}>
                  <Typography variant="subtitle2" gutterBottom color="primary">
                    Notes méthodologiques
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Les données présentées sont issues du Recensement Général de la Population. 
                    Les chiffres incluent uniquement la population des ménages ordinaires.
                    Les pourcentages sont calculés par rapport à la population totale de la commune de KAYANZA ({keyStats.totalPopulation} habitants).
                  </Typography>
                </Paper>
              </Grid>
            </Grid>
          </Container>
        </ContentWrapper>

        
        {!isMobile ? (
          <RightDrawerWrapper>
            <SideMenuBuhumuza />
          </RightDrawerWrapper>
        ) : (
          <Drawer
            variant="temporary"
            anchor="right"
            open={mobileRightOpen}
            onClose={handleRightDrawerToggle}
            ModalProps={{
              keepMounted: true,
            }}
            sx={{
              '& .MuiDrawer-paper': { boxSizing: 'border-box', width: rightDrawerWidth },
            }}
          >
            <SideMenuBuhumuza /> 
          </Drawer>
        )}
      </MainContentWithDrawer>
      <Footer />
    </MainContainer>
  );
};

export default PopulationDataPageButanyereraKayanza;